import { Controller } from "@hotwired/stimulus"

// Palabras clave (SEO) como chips. Mantiene sincronizado un input hidden con
// los valores separados por coma, que es el formato que espera Resource#keywords.
export default class extends Controller {
  static targets = ["input", "hidden", "list", "template"]

  connect() {
    this.tags = this.#parse(this.hiddenTarget.value)
    this.#render()
  }

  keydown(event) {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault()
      this.commit()
    } else if (event.key === "Backspace" && this.inputTarget.value === "") {
      this.tags.pop()
      this.#render()
    }
  }

  commit() {
    const value = this.inputTarget.value.trim().replace(/,+$/, "").trim()
    if (value && !this.tags.includes(value)) this.tags.push(value)
    this.inputTarget.value = ""
    this.#render()
  }

  remove(event) {
    event.preventDefault()
    const { tag } = event.target.closest("[data-tag]").dataset
    this.tags = this.tags.filter((item) => item !== tag)
    this.#render()
  }

  #parse(value) {
    return (value || "").split(",").map((tag) => tag.trim()).filter(Boolean)
  }

  #render() {
    this.hiddenTarget.value = this.tags.join(", ")
    this.listTarget.innerHTML = this.tags
      .map((tag) => this.templateTarget.innerHTML.replace(/TAG_VALUE/g, this.#escape(tag)))
      .join("")
  }

  #escape(value) {
    const element = document.createElement("div")
    element.textContent = value
    return element.innerHTML.replace(/"/g, "&quot;")
  }
}
